import { FC } from 'react';
import type { ResourcesOption } from '../../types';
import ResourcesPopup from '../ResourcesPopup/ResourcesPopup';

interface FooterProps {
  resourcesOptions: ResourcesOption[];
  isExpanded: boolean;
}

const Footer: FC<FooterProps> = ({ resourcesOptions, isExpanded }) => {
  return (
    <div className='flex flex-col gap-y-2 px-1'>
      <ResourcesPopup
        resourcesOptions={resourcesOptions}
        isExpanded={isExpanded}
      />
    </div>
  );
};

export default Footer;
